<template>
    <v-dialog v-model="dialog" width="800" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="so_number"
                                :rules="[formRules.required]"
                                label="Special Order Number"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-autocomplete
                                v-model="category"
                                :rules="[formRules.required]"
                                label="Category"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :items="categoryData"
                                item-title="name"
                                item-value="value"
                                >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea
                                v-model="title"
                                :rules="[formRules.required]"
                                label="Title"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                >
                            </v-textarea>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-date-input
                                v-model="start_date"
                                prepend-icon=""
                                prepend-inner-icon="mdi-calendar"
                                :rules="[formRules.required]"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                label="Start Date"
                            ></v-date-input>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-date-input
                                v-model="end_date"
                                prepend-icon=""
                                prepend-inner-icon="mdi-calendar"
                                :rules="[formRules.required, formRules.endAfterStart]"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                label="End Date"
                            ></v-date-input>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="remarks"
                                label="Remarks"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
    emits: ["refresh"],
    data () {
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            so_number: null,
            title: null,
            start_date: null,
            end_date: null,
            category: null,
            remarks: null,

            categoryData: [
                { name: 'Research', value: 'Res' },
                { name: 'Extension', value: 'Ext' },
            ],

            formRules: {
                required: v => !!v || 'Required.',
                endAfterStart: v => {
                    if (!v || !this.start_date) return true
                    return new Date(v) > new Date(this.start_date) || 'End Date must be greater than Start Date'
                }
            }
        }
    },
    methods: {
        initAdd(){
            this.dialog = true
            this.dialog_title = 'REP Load Title'
            this.dialog_sub_title = 'Add new rep load title'
            this.action = 'add'
        },
        initEdit(data){
            this.dialog = true
            this.dialog_title = 'REP Load Title'
            this.dialog_sub_title = 'Update rep load title'
            this.action = 'edit'

            this.id = data.id
            this.so_number = data.so_number
            this.category = data.category,
            this.title = data.title
            this.start_date = new Date(data.start_date)
            this.end_date = new Date(data.end_date)
            this.remarks = data.remarks
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()

            if(valid){
                this.loading = true
                let formData = {
                    id: this.id,
                    so_number: this.so_number,
                    title: this.title,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    category: this.category,
                    remarks: this.remarks,
                    semester_schoolyear: this.$store.state.semester_schoolyear.id
                }

                const token = localStorage.getItem('aums-token')

                if(this.action == 'add')[
                    axios.post(process.env.VUE_APP_SERVER_URL + '/rep-title', formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 200){
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('REP Load Title successfully added!')
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error)=>{
                        if(error.response.status == 401){
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                ]
                else if(this.action == 'edit'){
                    axios.patch(process.env.VUE_APP_SERVER_URL + '/rep-title', formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 200){
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('REP Load Title successfully updated!')
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error)=>{
                        if(error.response.status == 401){
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                }
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
    }
})
</script>

<style scoped>

</style>